export default {
  initiate: "Initiating...",
  login_required: "You need to login in order to use the app.",
  error_initiate:
    "There was an error during app initiation/user sign-in. Please try again or contact {url} for assistance.",
  error_offline:
    "The app is unable to access the internet. Offline mode can first be used after the app has downloaded what it needs from a Workspace.",
  try_again: "Try Again",
}
